type apiParams = string | number;

export const __API = {
    overview: {
        allRange: 'https://cboverview.bing-net.com/overview/range',
        subscriberRange: 'https://cboverview.bing-net.com/overview/rangeSubscribers',
        orderRange: 'https://cboverview.bing-net.com/overview/rangeOrders',
        paymentRange: 'https://cboverview.bing-net.com/overview/rangePayments',
        accountRange: 'https://cboverview.bing-net.com/overview/rangeAccounts'
    }
}